import { useContext } from 'react'
import { ModalContext } from './contexts'
import cookie from 'react-cookies'
import { DateTime } from 'luxon'

export const useSudo = (click) => {
  const sudoCookie = cookie.load('sudo')
  const { setOnSudo, modal } = useContext(ModalContext)

  if (!sudoCookie) {
    return () => {
      setOnSudo(() => () => {
        cookie.save('sudo', true, {
          expires: DateTime.now().plus({ minutes: 15 }).toJSDate(),
        })
        click()
      })
      modal.show()
    }
  } else {
    return () => click()
  }
}
